import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Annulla ordine',
  title: 'Non rifiutare mai alla leggera!',
  text: "Se c'è un problema minore con l'ordine, chiama il cliente e risolvilo.",
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Articoli esauriti',
    [OrderRejectionReason.ClosingSoon]: 'Negozio chiuso',
    [OrderRejectionReason.StoryBusy]: 'Negozio troppo occupato',
    [OrderRejectionReason.CustomerMistake]: 'Il cliente ha chiamato per annullare',
    [OrderRejectionReason.DriverNotArrived]: 'Autista non arrivato',
  },
  buttons: {
    confirm: 'Conferma',
  },
};
